import importAssets from 'helper/import-assets';

export default importAssets(require.context('./files/', true, /\.\/.*\.svg$/));
